import {call, takeLatest, put, take} from 'redux-saga/effects'

import {
  setUserToken,
  requestLogin,
  requestLoginFailure,
  logout,
  logoutSuccess,
  cleanDirtyForm,
  onClickOkPrompt,
  onClickCancelPrompt,
  setRouterPrompt,
} from '../slices/userSlice'
import {getLoginRequest} from '../../core/services/api/userApi'
import {enqueueSnackBar} from '../slices/notificationsSlice'
import {formatMessagesFromResponse} from 'utils/format'
import Auth from 'core/services/auth/Auth'
import localize from 'utils/localizer'
import {paths, severityTypes} from 'core/constants'
import history from 'core/services/history'

const loginSuccessMessageFormat = {
  message: localize('login.successMessage'),
  key: new Date().getTime() + Math.random(),
  options: {
    variant: severityTypes.SUCCESS,
  },
}

function* handleSendLoginRequest(action) {
  try {
    const {userData} = action.payload
    const response = yield call(getLoginRequest, userData)
    yield put(setUserToken(response.data))
    yield put(enqueueSnackBar(loginSuccessMessageFormat))
  } catch (error) {
    yield put(requestLoginFailure())
    yield put(enqueueSnackBar(formatMessagesFromResponse(error.response)))
  }
}

function* handleLogout() {
  yield put(cleanDirtyForm())
  yield call(Auth.removeUserInfo)
  yield call(history.push, paths.LOGIN)
  yield put(logoutSuccess())
}

export function* handleOnClickPrompt() {
  yield put(cleanDirtyForm())
  yield put(setRouterPrompt({isOpen: false}))
}

export function* handleOnClickCancelPrompt() {
  yield put(setRouterPrompt({isOpen: false}))
}

export function* handleForceToOpenPrompt({
  payload: {onClickOk, onClickCancel} = {},
} = {}) {
  const action = yield take([onClickOkPrompt.type, onClickCancelPrompt.type])

  if (action?.type === onClickOkPrompt.type && onClickOk) {
    yield call(onClickOk)
  }

  if (action?.type === onClickCancelPrompt.type && onClickCancel) {
    yield call(onClickCancel)
  }
}

export default function* watchUserSagas() {
  yield takeLatest(requestLogin, handleSendLoginRequest)
  yield takeLatest(setRouterPrompt, handleForceToOpenPrompt)
  yield takeLatest(onClickOkPrompt, handleOnClickPrompt)
  yield takeLatest(onClickCancelPrompt, handleOnClickCancelPrompt)
  yield takeLatest(logout, handleLogout)
}
